import './post.css';
// import { fabric } from 'fabric';
import Like from '../like/Like'; // adjust the path as needed
import MyFriendsToSharePost from '../../components/myFriendsToSharePost/MyFriendsToSharePost';
import { MoreVert } from '@material-ui/icons';
import { IconButton, MenuItem, Menu } from '@material-ui/core';
import {
  useContext,
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from 'react';
//import { Button, Comment, Form, Header } from 'semantic-ui-react';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import axiosConn from '../../axiosConn';
import { CircularProgress } from '@material-ui/core';
// import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import DynamicHtml from '../dynamicHtml/DynamicHtml';
import Comment from '../comment/Comment';
import CreateComment from '../createComment/CreateComment';
// import { format } from 'timeago.js';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { useMediaQuery } from 'react-responsive';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CurrencyExchangeOutlinedIcon from '@mui/icons-material/CurrencyExchangeOutlined';
import { Tooltip } from '@mui/material';
import useClickOutside from '../../clickOutside';
// import { ClipLoader } from 'react-spinners';
import Modal from '../modal/Modal';
import checkHtmlDialogElement from '../../utils/checkHtmlDialogElement';
import playSound from '../../utils/playSound';
import { SocketContext } from '../../context/socket';
import { ViewPortContext } from '../../context/ViewPortContext';
import Form from 'react-bootstrap/Form';

import preciseFormat from '../../utils/preciseFormat';
import PostMediaCarousel from './PostMediaCarousel';
import { useTheme } from '../../context/ThemeContext';
import useStyles from '../../utils/useStyles';
import { Room } from '@material-ui/icons';
import ReactionBar from '../reactionBar/ReactionBar';
import './localops-post.css';
import '../../styles/jgLocalOpsBadge.css';
import JGLocalOpsMark from '../common/JGLocalOpsMark';
import getDistanceFromLatLonInMeters from '../../utils/getDistanceFromLatLonInMeters';
import getShareUrl from '../../utils/getShareUrl';

const winningSound =
  'https://res.cloudinary.com/joegalaxy/video/upload/v1713899521/y2mate_HrgsElu_gxito3.mp3';

const normalizePostAuthorValue = (value) => {
  const text = String(value || '').trim();
  return text.length ? text : null;
};

const resolvePostAuthor = (post) => {
  if (!post || typeof post !== 'object') return null;
  const author = post.author || null;
  const playerId =
    author?.playerId ||
    author?._id ||
    post.playerId ||
    post.user?.playerId ||
    post.creator?.playerId ||
    post.userId?.playerId ||
    null;
  const profilePhoto =
    author?.profilePhoto ||
    post.profilePhoto ||
    post.user?.profilePhoto ||
    post.creator?.profilePhoto ||
    post.userId?.profilePhoto ||
    null;
  const rawId =
    post.userId?._id ||
    post.creator?._id ||
    post.user?._id ||
    (typeof post.userId === 'string' ? post.userId : null) ||
    (typeof post.creator === 'string' ? post.creator : null) ||
    null;
  const resolvedPlayerId = normalizePostAuthorValue(playerId);
  const resolvedProfilePhoto = normalizePostAuthorValue(profilePhoto);
  const resolvedId =
    normalizePostAuthorValue(rawId) || resolvedPlayerId || null;
  if (!resolvedPlayerId && !resolvedProfilePhoto) return null;
  return {
    playerId: resolvedPlayerId || null,
    profilePhoto: resolvedProfilePhoto || null,
    _id: resolvedId || null,
  };
};

const normalizeLocalOpsMeta = (post) => {
  const meta = post?.meta || {};
  if (meta.localops) return meta.localops;
  if (post?.context && post.context.startsWith('localops.')) {
    return {
      entityType: post.context.replace('localops.', ''),
      shareUrl: post?.meta?.shareUrl || null,
      regionLabel: post?.meta?.regionLabel || null,
      status: post?.meta?.status || null,
      priceUsd: post?.meta?.priceUsd || null,
      priceJGK: post?.meta?.priceJGK || null,
      owner: post?.meta?.owner || null,
      task: post?.meta?.task || null,
      offering: post?.meta?.offering || null,
    };
  }
  return null;
};

const buildLocationChip = ({ post, viewerLat, viewerLon }) => {
  const rawRegion = post?.meta?.regionLabel || '';
  const rawAddress = post?.location?.address || '';
  const source = rawRegion || rawAddress || '';

  const sanitize = (input) => {
    const tokens = String(input || '')
      .split(',')
      .map((p) => p.trim())
      .filter(Boolean)
      // drop tokens that contain digits (street numbers, ZIPs)
      .filter((p) => !/\d/.test(p));
    if (tokens.length >= 2) return `${tokens[tokens.length - 2]}, ${tokens[tokens.length - 1]}`;
    if (tokens.length === 1) return tokens[0];
    return '';
  };

  const coarseLabel = sanitize(source) || 'Local';

  const hasCoords =
    post?.location?.coordinates &&
    Array.isArray(post.location.coordinates) &&
    post.location.coordinates.length === 2;
  if (!hasCoords) return coarseLabel;

  const [lon, lat] = post.location.coordinates;
  if (
    Number.isFinite(lat) &&
    Number.isFinite(lon) &&
    Number.isFinite(viewerLat) &&
    Number.isFinite(viewerLon)
  ) {
    const dist = getDistanceFromLatLonInMeters(viewerLat, viewerLon, lat, lon);
    const nearby = Number.isFinite(dist) && dist <= 40233.5; // 25 mi
    return nearby ? `Nearby · ${coarseLabel}` : coarseLabel;
  }
  return coarseLabel;
};

const buildLocalOpsLink = (localops) => {
  if (!localops) return null;
  const shareUrl = localops.shareUrl || null;
  const continueUrl = localops.continueUrl || null;
  if (continueUrl) {
    return { share: continueUrl };
  }
  if (!shareUrl) return null;
  if (shareUrl.startsWith('/share/')) {
    const parts = shareUrl.split('/');
    const type = parts[2];
    const id = parts[3];
    if (type && id) {
      return {
        map: { type, id },
        share: shareUrl,
      };
    }
  }
  return { share: shareUrl };
};

export default function Post({
  galaxy = null,
  initialPost,
  onDelete,
  // handlePostClick
  isShareLanding = false,
  primaryCtaOverride = null,
  continuationOverride = null,
}) {
  // console.log(initialPost);
  const authCtx = useContext(AuthContext) || {};
  const fallbackPlayer = useMemo(
    () => ({
      data: {
        player: {
          _id: null,
          playerId: '',
          friends: [],
          jgkTokens: 0,
        },
      },
      token: null,
    }),
    [],
  );
  const loggedInPlayer = authCtx.player || fallbackPlayer;
  const currentPlayer = authCtx.player || fallbackPlayer;
  const [post, setPost] = useState(initialPost);
  const checkbox = useRef();

  const [like, setLike] = useState(post?.likes?.length || 0);
  const [share, setShare] = useState(
    (post?.rePosts?.length || 0) + (post?.reShares?.length || 0),
  );
  const [jgkd, setJgkd] = useState(post?.jgkd?.length || 0);
  // const [isJgkd, setIsJgkd] = useState(false);
  const [isLiked, setIsLiked] = useState(false);
  // const [isShared, setIsShared] = useState(false);

  const [views, setViews] = useState(post?.views);

  const [player, setPlayer] = useState(
    () => resolvePostAuthor(initialPost) || {},
  );
  const PF = process.env.REACT_APP_PUBLIC_FOLDER;
  const currentPlayerId =
    currentPlayer?.data?.player?.playerId ||
    currentPlayer?.data?.playerId ||
    currentPlayer?.playerId ||
    '';
  const currentPlayerDbId =
    currentPlayer?.data?.player?._id ||
    currentPlayer?.data?._id ||
    currentPlayer?._id ||
    '';
  const localOpsMeta = useMemo(() => normalizeLocalOpsMeta(post), [post]);
  const localOpsLink = useMemo(() => buildLocalOpsLink(localOpsMeta), [localOpsMeta]);
  const paymentDisplay = useMemo(() => {
    if (!localOpsMeta) return { priceLine: null, escrowLine: null };
    const isTask = localOpsMeta.entityType === 'task';
    const parseNumber = (value) => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : null;
    };
    const priceUsd =
      parseNumber(localOpsMeta.priceUsd) ??
      parseNumber(localOpsMeta.task?.priceUsd) ??
      parseNumber(localOpsMeta.task?.price) ??
      parseNumber(localOpsMeta.offering?.priceUsd) ??
      parseNumber(localOpsMeta.offering?.price) ??
      null;
    const priceJgk =
      parseNumber(localOpsMeta.priceJGK) ??
      parseNumber(localOpsMeta.task?.requiredJGK) ??
      parseNumber(localOpsMeta.task?.requiredJgk) ??
      parseNumber(localOpsMeta.requiredJGK) ??
      (priceUsd !== null ? priceUsd * (localOpsMeta.jgkPerUsd || 1000) : null);
    const rate =
      Number(localOpsMeta.jgkPerUsd) > 0 ? localOpsMeta.jgkPerUsd : 1000;
    const usdFromJgk =
      priceUsd === null && priceJgk !== null ? priceJgk / rate : priceUsd;
    const finalPriceUsd = usdFromJgk;
    const formatUsdLabel = (value) =>
      value === null ? null : `$${Number(value).toFixed(2)}`;
    const formatJgkLabel = (value) =>
      value === null ? null : `${Math.round(value).toLocaleString()} JGK`;
    const offeringStatus = String(
      localOpsMeta.offering?.reservationStatus ||
        localOpsMeta.offering?.status ||
        localOpsMeta.status ||
        '',
    ).toLowerCase();
    const offeringIsReserved =
      localOpsMeta.offering?.isReserved === true ||
      localOpsMeta.offering?.order?.escrowStatus === 'held' ||
      localOpsMeta.escrowStatus === 'held' ||
      ['reserved', 'in_progress', 'in-progress', 'active_reserved'].includes(
        offeringStatus,
      );
    const showEscrow = isTask || offeringIsReserved;
    const usdLabel = formatUsdLabel(finalPriceUsd);
    return {
      priceLine: usdLabel
        ? `${isTask ? 'Paid today' : 'Price'}: ${usdLabel}`
        : null,
      escrowLine:
        showEscrow && priceJgk !== null
          ? `(${formatJgkLabel(priceJgk)} escrowed)`
          : null,
    };
  }, [localOpsMeta]);

  const resolveShareUrl = useCallback(() => {
    const target = localOpsLink?.share || '';
    if (!target) return '';
    // Absolute URL provided by backend
    if (/^https?:\/\//i.test(target)) return target;
    // Relative share path like /share/task/:id
    if (target.startsWith('/share/')) {
      const parts = target.split('/');
      const type = parts[2];
      const id = parts[3];
      if (type && id) return getShareUrl(type, id);
    }
    // Fallback: derive from entityType + post id if possible
    const type =
      localOpsMeta?.entityType === 'offering'
        ? 'offering'
        : localOpsMeta?.entityType || 'task';
    const id =
      localOpsMeta?.task?.id ||
      localOpsMeta?.task?._id ||
      localOpsMeta?.offering?.id ||
      localOpsMeta?.offering?._id ||
      null;
    if (type && id) return getShareUrl(type, id);
    return target;
  }, [localOpsLink?.share, localOpsMeta]);
  const locationChip = useMemo(() => {
    const viewerLat = currentPlayer?.data?.player?.lastLocation?.coordinates
      ? currentPlayer.data.player.lastLocation.coordinates[1]
      : null;
    const viewerLon = currentPlayer?.data?.player?.lastLocation?.coordinates
      ? currentPlayer.data.player.lastLocation.coordinates[0]
      : null;
    return buildLocationChip({
      post,
      viewerLat,
      viewerLon,
    });
  }, [post, currentPlayer]);
  const contextLabel = post?.contextLabel || '';
  const localOpsIsOwner = useMemo(() => {
    if (!localOpsMeta) return false;
    const ownerHandle =
      localOpsMeta?.owner?.playerId ||
      post?.playerId ||
      post?.author?.playerId ||
      null;
    const ownerId =
      localOpsMeta?.owner?._id ||
      post?.userId?._id ||
      post?.creator?._id ||
      post?.author?._id ||
      null;
    const viewerHandle = currentPlayerId;
    const viewerId = currentPlayerDbId;
    return (
      (ownerHandle && viewerHandle && String(ownerHandle) === String(viewerHandle)) ||
      (ownerId && viewerId && String(ownerId) === String(viewerId))
    );
  }, [localOpsMeta, post, currentPlayerId, currentPlayerDbId]);
  const authorFromPost = useMemo(() => resolvePostAuthor(post), [post]);
  const [anchorEl, setAnchorEl] = useState(null);
  //const [isCloud, setIsCloud] = useState(false);
  const [commentCount, setCommentCount] = useState(1);
  const [comments, setComments] = useState(post?.comments || []);
  const commentCountRef = useRef(1);

  const [likePlayer, setLikePlayer] = useState({});
  const [likeProfileImgs, setlikeProfileImgs] = useState([]);
  const [messageTextIsVideo, setMessageTextIsVideo] = useState(false);
  const [jgkOnPost, setJGKOnPost] = useState(false);
  const [jgkTokens, setJgkTokens] = useState(post?.jgkTokens || 0);
  const [isLoading, setIsLoading] = useState(false);
  const [sendJGKToPostAmount, setSendJGKToPostAmount] = useState(0);
  const [myFriends, SetMyFriends] = useState([]);
  const [myFriendsToSharePost, SetMyFriendsToSharePost] = useState([]);
  const handleLocalOpsNavigate = useCallback(() => {
    if (!localOpsLink) return;
    if (localOpsLink.map) {
      const detail = {
        type: localOpsLink.map.type,
        id: localOpsLink.map.id,
      };
      window.dispatchEvent(new CustomEvent('localops:navigate', { detail }));
      const targetUrl = `/playermap?type=${detail.type}&id=${detail.id}`;
      if (window.location.pathname !== '/playermap') {
        window.location.href = targetUrl;
      }
    } else if (localOpsLink.share) {
      window.location.href = localOpsLink.share;
    }
  }, [localOpsLink]);

  const { socket: socket2 } = useContext(SocketContext);
  const [onlinePlayers, setOnlinePlayers] = useState([]);
  const [currentChat, setCurrentChat] = useState(null);
  const [loading, setLoading] = useState(false);
  // const [repostTrigger, setRepostTrigger] = useState(false); // State variable to track reposts

  // let subtitle;
  const [modal, setModal] = useState(false);
  const [isShare, setIsShare] = useState(false);
  const [isRepost, setIsRepost] = useState(false);
  const [dialogIsSupported, setDialogIsSupported] = useState(false);
  const imgRef = useRef(null);
  const [textPosition, setTextPosition] = useState({ top: '0px', left: '0px' });
  const [isSoundPlaying, setIsSoundPlaying] = useState(false);
  const [showText, setShowText] = useState(false);
  const [liveViewers, setLiveViewers] = useState(0);
  const [commentTypingHint, setCommentTypingHint] = useState('');
  const typingTimeoutRef = useRef(null);

  useEffect(() => {
    if (!authorFromPost) return;
    setPlayer((prev) => ({ ...prev, ...authorFromPost }));
  }, [authorFromPost]);

  useEffect(() => {
    setJgkd(post?.jgkd?.length || 0);
    setJgkTokens(post?.jgkTokens || 0);
  }, [post?.jgkd, post?.jgkTokens]);

  //const MyOptions = ['Delete Post', 'Edit Post'];
  const MyOptions = ['Delete Post'];
  const mobileView = useMediaQuery({
    query: '(max-width: 805px)',
  });
  const { width } = useContext(ViewPortContext);
  const numOfImages = width <= 280 ? 4 : 6;
  const menu = useRef(null);
  const [isShownMenuItem, setIsShownMenuItem] = useState(false);

  const handleReact = async (type) => {
    await axiosConn.put(
      `posts/${post._id}/react`,
      {
        playerId: currentPlayer.data.player.playerId,
        type,
        profilePhoto: currentPlayer.data.player.profilePhoto,
      },
      {
        headers: { Authorization: `Bearer ${currentPlayer.token}` },
      },
    );
    // Fetch updated post and update state
    const res = await axiosConn.get(`posts/${post._id}`, {
      headers: { Authorization: `Bearer ${currentPlayer.token}` },
    });
    // console.log('Post after reaction:', res.data.data.data);
    setPost(res.data.data.data);
    socket2.emit('updatePost', { updatedPost: res.data.data.data });
  };

  useClickOutside(menu, () => setIsShownMenuItem(false));
  const { darkTheme: ctxDarkTheme } = useTheme();
  const darkTheme = isShareLanding ? true : ctxDarkTheme;
  const classes = useStyles({ darkTheme });

  const handleClick = (event) => {
    // console.log(event.currentTarget);
    setAnchorEl(event.currentTarget);
    setIsShownMenuItem(true);
  };

  const open = Boolean(anchorEl);

  const handleClose = async () => {
    setAnchorEl(null);
    // console.log(post?.desc);
    // console.log(currentPlayer);
    // Emit the deletePost event to the server
    socket2.emit('deletePost', { post: initialPost });

    try {
      //const res =
      await axiosConn.delete(`posts/${post._id}`, {
        headers: {
          Authorization: `Bearer ${currentPlayer.token}`,
        },
        data: {
          playerId: currentPlayer.data.player.playerId,
        },
      });
      onDelete(initialPost._id);
      //console.log(res.data);
    } catch (err) {
      console.log(err);
    }
    // window.location.reload();
  };

  
  useEffect(() => {
    let mounted = true;
    //This grabs logged on player's friends.
    if (isShareLanding || !loggedInPlayer?.token || !loggedInPlayer?.data?.player?._id) {
      return () => {
        mounted = false;
      };
    }
    const getMyFriends = async () => {
      try {
        const friendList = await axiosConn.get(
          'players/friends/' + loggedInPlayer.data.player._id,
          {
            headers: {
              Authorization: `Bearer ${loggedInPlayer.token}`,
            },
          },
        );
        if (!mounted) return;
        const safeFriends = Array.isArray(friendList.data)
          ? friendList.data.filter((f) => f && f._id)
          : [];
        if (safeFriends.length !== (friendList.data?.length || 0)) {
          console.warn('[Post] filtered stale/null friends', {
            requested: friendList.data?.length || 0,
            kept: safeFriends.length,
          });
        }
        SetMyFriends(safeFriends);
      } catch (err) {
        console.warn('[Post] failed to load friends', err?.message || err);
        if (!mounted) return;
        SetMyFriends([]);
      }
    };
    getMyFriends();
    return () => {
      mounted = false;
    };
  }, [isShareLanding, loggedInPlayer.token, loggedInPlayer.data.player._id]);

  useEffect(() => {
    setPost(initialPost);
    setLike(initialPost?.likes?.length || 0);
    setComments(initialPost?.comments || []);
    setCommentCount(initialPost?.comments?.length || 0);
    setCommentCount(2); // Reset to initial number of comments to show
  }, [initialPost]);

  const likeHandler = async () => {
    try {
      const response = await axiosConn.put(
        'posts/' + post._id + '/like',
        {
          playerId: currentPlayer.data.player.playerId,
          profilePhoto: currentPlayer.data.player.profilePhoto,
        },
        {
          headers: {
            Authorization: `Bearer ${currentPlayer.token}`,
          },
        },
      );

      setLike(isLiked ? like - 1 : like + 1);
      setIsLiked(!isLiked);

      // console.log(response.data.data.post);
      // updatePost(response.data.data.post);

      // Emit the updated post to the server
      socket2.emit('updatePost', { updatedPost: response.data.data.post });
    } catch (err) {
      console.error(err);
    }
  };

  const rePostHandler = async () => {
    //console.log(currentPlayer);
    // console.log('rePostHander Top');
    try {
      const res = await axiosConn.put(
        'posts/' + post._id + '/repost',
        {
          playerId: currentPlayer.data.player.playerId,
        },
        {
          headers: {
            Authorization: `Bearer ${currentPlayer.token}`,
          },
        },
      );
      // console.log(res.data.data.post);

      socket2.emit('sendPost', { post: res.data.data.post });
    } catch (err) {}
    setShare((prev) => prev + 1);
    // setIsLiked(!isLiked);
  };
  const shareHandler = async () => {
    //console.log(currentPlayer);
    // console.log('shareHander Top');
    try {
      const res = await axiosConn.put(
        'posts/' + post._id + '/reshare',
        {
          playerId: currentPlayer.data.player.playerId,
        },
        {
          headers: {
            Authorization: `Bearer ${currentPlayer.token}`,
          },
        },
      );
      // console.log(res.data);
      if (!res.data.includes('The post has already been reShared')) {
        setShare((prev) => prev + 1);
      }
    } catch (err) {}
    // setIsLiked(!isLiked);
  };

  const showMore = () => {
    setCommentCount((prev) => prev + 3);
    commentCountRef.current += 3; // Show 3 more comments
  };

  useEffect(() => {
    if (isShareLanding || !post || typeof post !== 'object') {
      return null;
    }
    if (!currentPlayer?.token || !post?._id) {
      return null;
    }
    //setting views
    axiosConn
      .put(
        'posts/' + post._id + '/view',
        {},
        {
          headers: {
            Authorization: `Bearer ${currentPlayer.token}`,
          },
        },
      )
      .catch((err) => {
        console.error(
          'View update failed',
          err?.response?.data || err.message || err,
        );
      });
    //console.log(post);
    setViews((view) => view + 1);
    return () => {};
  }, [isShareLanding, currentPlayer?.token, post?._id]);

  // console.log(post);
  const handleClickJGKOnPostToggle = (event) => {
    // console.log('handleClickJGKOnPostToggle', jgkOnPost);
    jgkOnPost === false ? setJGKOnPost(true) : setJGKOnPost(false);
  };

  const handleSendJGKToPostAmount = async (e) => {
    // console.log('handleSendJGKToPostAmount');
    if (isSoundPlaying) return; // Prevent function from running if sound is playing

    // console.log(e.target.value);
    if (e.key === 'Enter' || e.type === 'click') {
      //send JGK.
      setIsLoading(true);

      // console.log(myFriends);
      // Debug: inspect playerId matching vs friends list
      console.log('[JGK][send] post.playerId', post?.playerId);
      console.log('[JGK][send] myFriends length', myFriends?.length || 0);
      const postPlayerId = myFriends.filter(
        (f) => post?.playerId === f.playerId,
      );
      console.log('[JGK][send] postPlayerId matches', postPlayerId);

      let receiver;
      if (post.galaxyId) {
        receiver = post.playerId;
      } else {
        if (postPlayerId.length === 0) {
          // Handle the case where post.playerId is not in myFriends
          setIsLoading(false);
          console.warn('[JGK][send] receiver not found in myFriends');
          return;
        }
        receiver = postPlayerId[0]._id;
      }
      // console.log(
      //   postPlayerId[0]._id,
      //   loggedInPlayer.data.player._id,
      //   sendJGKToPostAmount,
      // );

      if (sendJGKToPostAmount > loggedInPlayer.data.player.jgkTokens) {
        //setError
        return;
      }

      try {
        // console.log('sender: ', loggedInPlayer.data.player._id);
        // console.log('receiver: ', postPlayerId[0]._id);
        // console.log('receivingPostId: ', post._id);
        // console.log(`text: POGW:${post?.playerId}:${post?.desc}: ${post?._id}`);
        // console.log(receiver);
        const res = await axiosConn.post(
          'jgkTokenTransactions/sendJGKToPostPOGW/',
          {
            receiver: receiver,
            receivingPostId: post._id,
            sender: loggedInPlayer.data.player._id,
            amount: sendJGKToPostAmount,
            text: `POGW:${post?.playerId}:${post?.desc}: ${post?._id}`,
          },
          {
            headers: {
              Authorization: `Bearer ${loggedInPlayer.token}`,
            },
          },
        );
        // window.location.href = res2.data.session.url;
        // console.log(res.data.post);
        // playSound
        setIsLoading(false);
        setJGKOnPost(false);
        setIsSoundPlaying(true); // Indicate that sound is about to play
        try {
          await playSound(winningSound);
        } catch (audioErr) {
          // swallow audio errors to avoid breaking flow
          console.warn('JGK audio failed to play', audioErr);
        } finally {
          setIsSoundPlaying(false); // Reset after sound has played
        }

        setPost(res.data.post);

        // Emit the updated post to the server
        socket2.emit('updatePost', { updatedPost: res.data.post });
      } catch (err) {
        setIsLoading(false);

        console.log(err);
      }
    }
  };

  useEffect(() => {
    if (isShareLanding || !modal) {
      return undefined;
    }
    if (!loggedInPlayer?.data?.player?.friends) {
      return undefined;
    }
    if (!socket2) {
      return undefined;
    }
    if (!loggedInPlayer?.data?.player?.friends) {
      return undefined;
    }
    if (isShareLanding) {
      return undefined;
    }
    if (modal) {
      // console.log('modal');
      socket2.on('getPlayers', (players) => {
        setOnlinePlayers(
          loggedInPlayer.data.player.friends.filter((f) =>
            players.some((u) => u.playerId === f),
          ),
        );
      });
    }
    return () => {
      // before the component is destroyed
      // unbind all event handlers used in this component
      socket2.off('getPlayers');
    };
  }, [isShareLanding, loggedInPlayer.data.player.friends, modal, socket2]);

  // Live post updates (comments, reactions, views, typing, live viewers)
  useEffect(() => {
    if (isShareLanding) return undefined;
    if (!socket2 || !post?._id) return undefined;

    const handleCommentsUpdate = ({ postId, comments: incoming }) => {
      if (postId !== post._id) return;
      const nextComments = incoming || [];
      setComments(nextComments);
      setCommentCount(nextComments.length || 0);
      if (nextComments.length > commentCountRef.current) {
        commentCountRef.current = nextComments.length;
      }
    };

    const handleTyping = ({ postId, playerId }) => {
      if (postId !== post._id) return;
      if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
      setCommentTypingHint(
        playerId ? `${playerId} is typing...` : 'Someone is typing...',
      );
      typingTimeoutRef.current = setTimeout(() => {
        setCommentTypingHint('');
      }, 5000);
    };

    const handleLiveViewers = ({ postId, count }) => {
      if (postId !== post._id) return;
      setLiveViewers(typeof count === 'number' ? Math.max(0, count) : 0);
    };

    const handleReactions = ({ postId, likes: likeArr, reactions }) => {
      if (postId !== post._id) return;
      if (Array.isArray(likeArr)) {
        setLike(likeArr.length);
        setPost((prev) => ({ ...prev, likes: likeArr }));
      }
      if (reactions) {
        setPost((prev) => ({ ...prev, reactions }));
      }
    };

    const handleViews = ({ postId, views: incomingViews }) => {
      if (postId !== post._id) return;
      if (typeof incomingViews === 'number')
        setViews(Math.max(0, incomingViews));
    };

    socket2.on('getPostCommentsUpdates', handleCommentsUpdate);
    socket2.on('post:comment:typing', handleTyping);
    socket2.on('post:liveViewers', handleLiveViewers);
    socket2.on('post:reaction', handleReactions);
    socket2.on('post:view', handleViews);
    const handlePostUpdate = ({ updatedPost }) => {
      if (!updatedPost?._id || updatedPost._id !== post._id) return;
      setPost(updatedPost);
    };
    socket2.on('updatePost', handlePostUpdate);

    return () => {
      socket2.off('getPostCommentsUpdates', handleCommentsUpdate);
      socket2.off('post:comment:typing', handleTyping);
      socket2.off('post:liveViewers', handleLiveViewers);
      socket2.off('post:reaction', handleReactions);
      socket2.off('post:view', handleViews);
      socket2.off('updatePost', handlePostUpdate);
      if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
    };
  }, [isShareLanding, post?._id, socket2]);

  const sharePostToMessenger = async (receiverPlayer, senderPlayer) => {
    // console.log(receiverPlayer, senderPlayer);
    if (receiverPlayer?._id && senderPlayer?._id) {
      try {
        const res = await axiosConn
          .get(
            `conversations/find/${receiverPlayer._id}/${senderPlayer._id}`,
            {
              headers: {
                Authorization: `Bearer ${loggedInPlayer.token}`,
              },
            },
          )
          .then(async (res) => {
            if (res.data === null) {
              // console.log('No conversation yet. creating...');
              try {
                //create new conversation.
                const res = await axiosConn.post(
                  `conversations/`,
                  {
                    senderId: loggedInPlayer.data.player._id,
                    receiverId: receiverPlayer._id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer ${loggedInPlayer.token}`,
                    },
                  },
                );

                // console.log(res.data);
                setCurrentChat(res.data);
                // console.log(
                //   'sending...to new conversation..conversationId: ',
                //   res.data._id,
                // );
                let message = {
                  sender: loggedInPlayer.data.player._id,
                  text: `sharedPost by ${post.desc}\nhttps://www.joegalaxy.net/post/${post._id} <-- click to goto sharedPost.`,
                  img: post.img,
                  conversationId: res.data._id,
                  // isRead: false,
                  isRead: onlinePlayers?.includes(receiverPlayer._id)
                    ? true
                    : false,
                };
                // console.log(message);
                //send to socket
                try {
                  socket2.emit('sendMessage', {
                    senderId: loggedInPlayer.data.player._id,
                    senderPlayerId: loggedInPlayer.data.player.playerId,
                    receiverId: receiverPlayer._id,
                    text: `sharedPost by ${post.desc}\nhttps://www.joegalaxy.net/post/${post._id} <-- click to goto sharedPost.`,
                    img: post.img,
                  });
                  // checkPageStatus(text, player.data.player._id);
                } catch (err) {
                  console.log(err);
                }

                // console.log(onlinePlayers.includes(receiverId) ? 'true' : 'false');
                try {
                  setLoading(true);
                  //send to messages table
                  const res = await axiosConn.post(
                    `/messages/${
                      onlinePlayers.includes(receiverPlayer._id)
                        ? 'true'
                        : 'false'
                    }`,
                    message,
                    {
                      headers: {
                        Authorization: `Bearer ${loggedInPlayer.token}`,
                      },
                    },
                  );
                  // console.log(res.data.data.data);
                  // console.log(...messages);
                  setLoading(false);
                } catch (err) {
                  setLoading(false);
                  console.log(err);
                }
              } catch (err) {
                console.log(err);
              }
            } else {
              //existing conversation.
              // console.log(
              //   'sending to existing conversation...conversationId: ',
              //   res.data._id,
              // );
              let message = {
                sender: loggedInPlayer.data.player._id,
                text: `sharedPost by ${post.playerId}: ${post.desc}\nhttps://www.joegalaxy.net/post/${post._id} <-- click to goto sharedPost.`,
                img: post.img,
                conversationId: res.data._id,
                // isRead: false,
                isRead: onlinePlayers?.includes(receiverPlayer._id)
                  ? true
                  : false,
              };
              // console.log(message);
              //send to sockedt
              try {
                socket2.emit('sendMessage', {
                  senderId: loggedInPlayer.data.player._id,
                  senderPlayerId: loggedInPlayer.data.player.playerId,
                  receiverId: receiverPlayer._id,
                  text: `sharedPost by ${post.playerId}: ${post.desc}\nhttps://www.joegalaxy.net/post/${post._id} <-- click to goto sharedPost.`,
                  img: post.img,
                });
                // checkPageStatus(text, player.data.player._id);
              } catch (err) {
                console.log(err);
              }

              // console.log(onlinePlayers.includes(receiverId) ? 'true' : 'false');
              try {
                setLoading(true);
                //send to messages
                const res = await axiosConn.post(
                  `/messages/${
                    onlinePlayers.includes(receiverPlayer._id)
                      ? 'true'
                      : 'false'
                  }`,
                  message,
                  {
                    headers: {
                      Authorization: `Bearer ${loggedInPlayer.token}`,
                    },
                  },
                );
                // console.log(res.data.data.data);
                // console.log(...messages);
                setLoading(false);
              } catch (err) {
                setLoading(false);
                console.log(err);
              }
            }
          });
      } catch (err) {
        console.log(err);
      }
    }
  };

  useEffect(() => {
    setDialogIsSupported(checkHtmlDialogElement());
  }, []);

  const handleSharePost = () => {
    setIsLoading(true);

    // console.log('handleSharePost Top');
    // console.log(myFriendsToSharePost);
    myFriendsToSharePost.forEach((friend) => {
      sharePostToMessenger(friend, loggedInPlayer.data.player);
      // sharePostToMessenger(post, friend);
    });
    shareHandler(); //add playerId to reShares on Post.

    setIsLoading(false);
    setModal(false);
  };

  const handleRepost = () => {
    setIsLoading(true);
    // console.log('handleRepost');
    rePostHandler();
    setModal(false);

    setIsLoading(false);
    // window.location.reload();
  };

  const handleIsShareClicked = () => {
    // console.log('handleIsShareClicked');
    setIsShare((prev) => !prev);
  };

  const handleIsRepostClicked = () => {
    // console.log('handleIsRepost');
    setIsRepost((prev) => !prev);
  };

  // Join/leave post room for live viewers/events
  useEffect(() => {
    if (isShareLanding) return undefined;
    if (!socket2 || !post?._id) return undefined;
    const payload = { postId: post._id };
    socket2.emit('post:join', payload);
    return () => {
      socket2.emit('post:leave', payload);
    };
  }, [isShareLanding, post?._id, socket2]);

  const sortedComments = useMemo(() => {
    if (!comments || comments.length === 0) return [];
    return [...comments].sort((a, b) => {
      return new Date(b.commentAt) - new Date(a.commentAt);
    });
  }, [comments]);

  // if (!post || typeof post !== 'object') {
  //   return null;
  // }
  // console.log(post);
  if (isShareLanding && localOpsMeta) {
    return (
      <div className={darkTheme ? 'postDarkTheme' : 'post'}>
        <div className="postWrapper">
          <div className="localops-hero-card">
            <div className="localops-hero-header">
              <div className="localops-signature">
                <JGLocalOpsMark />
              </div>
              <div className="localops-hero-pills">
                <span className="localops-pill-chip">
                  {localOpsMeta.entityType === 'offering' ? 'Offering' : 'Task'}
                </span>
                <span className="localops-pill-chip localops-pill-chip--ready">
                  {localOpsMeta.entityType === 'offering' ? 'Payment Ready' : 'Funded'}
                </span>
              </div>
              <div className="localops-hero-region">
                {locationChip || localOpsMeta.regionLabel || contextLabel || 'Nearby'}
              </div>
            </div>
            <div className="localops-hero-body">
              <div className="localops-hero-avatar">
                {player?.profilePhoto ||
                localOpsMeta?.owner?.profilePhoto ||
                post?.profilePhoto ? (
                  <img
                    src={
                      player?.profilePhoto ||
                      localOpsMeta?.owner?.profilePhoto ||
                      post?.profilePhoto
                    }
                    alt={player?.playerId || localOpsMeta?.owner?.playerId}
                  />
                ) : (
                  <span className="localops-avatar__fallback">
                    {(player?.playerId || localOpsMeta?.owner?.playerId || 'L').charAt(0)}
                  </span>
                )}
              </div>
              <div className="localops-hero-text">
                <div className="localops-hero-owner">
                  {player?.playerId ||
                    localOpsMeta?.owner?.playerId ||
                    localOpsMeta?.owner?.displayName ||
                    'LocalOps'}
                </div>
                <div className="localops-hero-title">
                  {post.title ||
                    post.desc ||
                    localOpsMeta?.task?.title ||
                    localOpsMeta?.offering?.title ||
                    'LocalOps'}
                </div>
                {paymentDisplay.priceLine ? (
                  <div className="localops-hero-price">
                    {paymentDisplay.priceLine}
                    {paymentDisplay.escrowLine ? (
                      <span className="localops-hero-price-sub">
                        {paymentDisplay.escrowLine}
                      </span>
                    ) : null}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="localops-hero-actions">
              <button
                type="button"
                className="localops-hero-btn"
                onClick={handleLocalOpsNavigate}
              >
                {primaryCtaOverride ||
                  (localOpsMeta.entityType === 'offering' ? 'Reserve' : 'Accept')}
              </button>
              <div className="localops-hero-secondary">
                <button
                  type="button"
                  className="localops-hero-link"
                  onClick={handleLocalOpsNavigate}
                >
                  View on map
                </button>
                {!isShareLanding && localOpsLink?.share ? (
                  <button
                    type="button"
                    className="localops-hero-link"
                    onClick={() => (window.location.href = localOpsLink.share)}
                  >
                    Share
                  </button>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <Tooltip
        title={
          post?.isPogw && post.playerId !== currentPlayer?.data.player.playerId
            ? `Proof Of Great Work, consider rewarding JGK`
            : null
        }
      >
        <div
          className={
            post?.isPogw ? 'postPOGW' : darkTheme ? 'postDarkTheme' : 'post'
          }
          // onClick={handlePostClick}
        >
          <div className="postWrapper">
            <div className="postTop">
              <div className="postTopLeft">
                <Link to={`/profile/${player?.playerId}`}>
                  <img
                    className={
                      !mobileView ? 'postProfileImg' : 'postProfileImgMobile'
                    }
                    src={
                      player.profilePhoto
                        ? player.profilePhoto
                        : 'https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1656194537/Images/noAvatar_tsgpm9.png'
                    }
                    alt=""
                    loading="lazy"
                  />
                </Link>
                <span
                  className={
                    !mobileView ? 'postPlayerId' : 'postPlayerIdMobile'
                  }
                >
                  {player.playerId}
                </span>
                <div className={!mobileView ? 'postViews' : 'postViewsMobile'}>
                  <VisibilityIcon sx={{ color: 'grey', fontSize: 15 }} />
                  {views}
                  {liveViewers > 0 && (
                    <span
                      style={{
                        marginLeft: 6,
                        fontSize: 11,
                        color: '#4caf50',
                        fontWeight: 600,
                      }}
                      title="Currently viewing"
                    >
                      • {liveViewers} live
                    </span>
                  )}
                </div>
                <span className={!mobileView ? 'postDate' : 'postDateMobile'}>
                  {preciseFormat(post?.createdAt)}
                </span>
                {post?.isPogw ? (
                  !mobileView ? (
                    <span className="pogwTitleSpan">Proof of Great Work</span>
                  ) : (
                    <span className="pogwTitleSpanMobile">POGW</span>
                  )
                ) : null}
              </div>
              <div
                className={`${
                  mobileView && post?.isPogw
                    ? 'postTopRightPOGW'
                    : 'postTopRight'
                } 
    ${darkTheme ? 'darkTheme blackBg' : ''}`}
              >
                {((post?.playerId ||
                  post?.user?.playerId ||
                  post?.userId?.playerId ||
                  post?.creator?.playerId ||
                  player?.playerId ||
                  '') === currentPlayerId ||
                  (post?.user?._id ||
                    post?.userId?._id ||
                    post?.creator?._id ||
                    post?.author?._id ||
                    '') === currentPlayerDbId ||
                  (galaxy &&
                    (galaxy.owners || []).some(
                      (owner) => owner._id === currentPlayer.data.player._id,
                    )) ||
                  (galaxy &&
                    (galaxy.administrators || []).some(
                      (admin) => admin._id === currentPlayer.data.player._id,
                    )) ||
                  (galaxy &&
                    (galaxy.moderators || []).some(
                      (moderator) =>
                        moderator._id === currentPlayer.data.player._id,
                    ))) && (
                  <IconButton
                    aria-label="more"
                    onClick={handleClick}
                    aria-haspopup="true"
                    aria-controls="long-menu"
                  >
                    <MoreVert
                      fontSize={!mobileView || width === 800 ? 'large' : 'small'}
                      style={{
                        color: darkTheme ? 'white' : 'inherit',
                      }}
                    />
                  </IconButton>
                )}
                {isShownMenuItem &&
                  player.playerId === currentPlayer.data.player.playerId && (
                    <Menu
                      anchorEl={anchorEl}
                      keepMounted
                      open={open}
                      classes={{ paper: classes.menu }}
                    >
                      {MyOptions.map((option, i) => (
                        <MenuItem
                          key={i}
                          onClick={handleClose}
                          ref={menu}
                          className={classes.menuItem}
                        >
                          {option}
                        </MenuItem>
                      ))}
                    </Menu>
                  )}
              </div>
            </div>
            {post?.isPogw && (
              <div>
                <Tooltip
                  title={`This post has ${(
                    Math.round(parseFloat(post?.jgkTokens) * 100) / 100
                  ).toFixed(2)} JGK`}
                >
                  <span
                    id="postJGKAmount"
                    className="postJGKAmount"
                    // className={
                    //   post?.jgkTokens < 9999
                    //     ? 'postNotificationIconBadgeJGK'
                    //     : 'postNotificationIconBadgeJGK10K'
                    // }
                  >
                    {post?.jgkTokens &&
                      (
                        Math.round(parseFloat(post?.jgkTokens) * 100) / 100
                      ).toFixed(2)}
                  </span>
                </Tooltip>
                <span className="postJGKBadge">JGK</span>
              </div>
            )}
            <div className="postTop">
              {localOpsMeta ? (
                <div className="localops-location-chip">{locationChip}</div>
              ) : post?.location?.coordinates ? (
                <div
                  className="flex-row"
                  style={{ textAlign: 'center', width: '100%' }}
                >
                  <Link
                    to={`/playerMap?lat=${post.location.coordinates[1]}&lon=${post.location.coordinates[0]}&parent=post`}
                    className="mmenu_header hover3"
                    title="View on map"
                  >
                    <Room
                      htmlColor="green"
                      className="shareIcon flashing-icon"
                    />
                  </Link>
                  {locationChip}
                </div>
              ) : null}
            </div>
            {localOpsMeta ? (
              <div className="localops-hero-card">
                <div className="localops-hero-header">
                  <div className="localops-signature">
                    <JGLocalOpsMark />
                  </div>
                  <div className="localops-hero-pills">
                    <span className="localops-pill-chip">
                      {localOpsMeta.entityType === 'offering'
                        ? 'Offering'
                        : 'Task'}
                    </span>
                    {localOpsMeta.priceUsd ? (
                      <span className="localops-pill-chip localops-pill-chip--ready">
                        {localOpsMeta.escrowStatus === 'held' ? 'Funded' : 'Payment Ready'}
                      </span>
                    ) : null}
                    {localOpsMeta.offering?.requestQuote ? (
                      <span className="localops-pill-chip">Quote required</span>
                    ) : null}
                  </div>
                  <div className="localops-hero-region">{locationChip}</div>
                </div>
                <div className="localops-hero-body">
                  <div className="localops-hero-avatar">
                    {player?.profilePhoto ||
                    localOpsMeta?.owner?.profilePhoto ||
                    post?.profilePhoto ? (
                      <img
                        src={
                          player?.profilePhoto ||
                          localOpsMeta?.owner?.profilePhoto ||
                          post?.profilePhoto
                        }
                        alt={player?.playerId || localOpsMeta?.owner?.playerId}
                      />
                    ) : (
                      <span className="localops-avatar__fallback">
                        {(player?.playerId ||
                          localOpsMeta?.owner?.playerId ||
                          'L'
                        ).charAt(0)}
                      </span>
                    )}
                  </div>
                  <div className="localops-hero-text">
                    <div className="localops-hero-owner">
                      {player?.playerId ||
                        localOpsMeta?.owner?.playerId ||
                        'LocalOps'}{' '}
                      {localOpsIsOwner ? '(You)' : ''}
                    </div>
                    <div className="localops-hero-title">
                      {post.title ||
                        post.desc ||
                        localOpsMeta?.task?.title ||
                        localOpsMeta?.offering?.title ||
                        'LocalOps'}
                    </div>
                    {paymentDisplay.priceLine ? (
                      <div className="localops-hero-price">
                        {paymentDisplay.priceLine}
                        {paymentDisplay.escrowLine ? (
                          <span className="localops-hero-price-sub">
                            {paymentDisplay.escrowLine}
                          </span>
                        ) : null}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="localops-hero-actions">
                  {!localOpsIsOwner ? (
                    <button
                      type="button"
                      className="localops-hero-btn"
                      onClick={handleLocalOpsNavigate}
                    >
                      {primaryCtaOverride
                        ? primaryCtaOverride
                        : localOpsMeta.entityType === 'offering'
                        ? 'Reserve'
                        : 'Accept'}
                    </button>
                  ) : null}
                  <div className="localops-hero-secondary">
                    <button
                      type="button"
                      className="localops-hero-link"
                      onClick={handleLocalOpsNavigate}
                    >
                      View on map
                    </button>
                    {!isShareLanding && localOpsLink?.share ? (
                    <button
                      type="button"
                      className="localops-hero-link"
                      onClick={async () => {
                          const shareUrl = resolveShareUrl();
                          if (!shareUrl) return;
                          if (navigator.share) {
                            try {
                              await navigator.share({ url: shareUrl });
                            } catch (err) {
                              console.warn('navigator.share failed', err);
                            }
                            return;
                          }
                          try {
                            await navigator.clipboard.writeText(shareUrl);
                          } catch (err) {
                            console.warn('clipboard write failed', err);
                          }
                      }}
                    >
                      Share
                    </button>
                  ) : null}
                  </div>
                </div>
              </div>
            ) : null}
            <div className="postCenter" ref={imgRef}>
              <DynamicHtml
                from="post"
                text={post?.desc}
                setMessageTextIsVideo={setMessageTextIsVideo}
              />
              <PostMediaCarousel item={post} autoPlay={true} enableZoom={true} />
            </div>
            {/* LocalOps posts: hide JGK/share/comment affordances per spec */}
            {!localOpsMeta && (
              <div className="sendJGKToPostPOGWWrapper">
                {post?.isPogw && (
                  <span className="pogwTitleSpanMobile">POGW</span>
                )}
                <div className={jgkOnPost ? 'pogwIconIconClicked' : 'pogwIcon'}>
                  <Tooltip
                    title={
                      jgkOnPost
                        ? 'click to close JGK.'
                        : `click to give JGK to ${post?.playerId} for this post.`
                    }
                  >
                    <CurrencyExchangeOutlinedIcon
                      onClick={
                        post?.playerId !== loggedInPlayer.data.player.playerId
                          ? handleClickJGKOnPostToggle
                          : null
                      }
                      fontSize={!mobileView ? 'medium' : 'small'}
                    />
                  </Tooltip>
                </div>
                {!jgkOnPost && (
                  <>
                    <span
                      className={
                        !mobileView
                          ? darkTheme
                            ? 'postJgkdCounter dark-theme blackBg'
                            : 'postJgkdCounter'
                          : 'postJgkdCounterMobile'
                      }
                    >
                      JGK: {jgkTokens || 0}
                    </span>
                    <div className="postLikeProfileImgs">
                      {jgkd > 0 &&
                        post?.jgkdProfileImgs &&
                        post?.jgkdProfileImgs
                          .slice(0, numOfImages)
                          .map((jgkdProfileImg, i) => (
                            <Link
                              to={`/profile/${jgkdProfileImg.playerId}`}
                              key={i}
                            >
                              <img
                                src={
                                  jgkdProfileImg.profilePhoto
                                    ? jgkdProfileImg.profilePhoto
                                    : 'https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1656194537/Images/noAvatar_tsgpm9.png'
                                }
                                alt=""
                                loading="lazy"
                                style={{
                                  transform: `translateX(${-i * 8}px)`,
                                  zIndex: `${i}`,
                                }}
                              />
                            </Link>
                          ))}
                    </div>
                  </>
                )}
                {jgkOnPost && (
                  <>
                    <div className="postJGKInputSend">
                      <div className="sendJGKToPostAmountInputs">
                        <label
                          className="sendJGKToPostAmountLabel"
                          htmlFor="sendJGKToPlayerAmount"
                        >
                          Amount:
                        </label>
                        <input
                          type="number"
                          value={sendJGKToPostAmount}
                          id="sendJGKToPlayerAmount"
                          onChange={(e) => setSendJGKToPostAmount(e.target.value)}
                          onKeyUp={handleSendJGKToPostAmount}
                        ></input>
                      </div>
                      <div className="sendJGKToPostPOGWButton">
                        <button
                          className={
                            !jgkOnPost || sendJGKToPostAmount < 1
                              ? 'sendJGKPostSubmitButtonDisabled'
                              : 'sendJGKPostSubmitButton'
                          }
                          value="Send"
                          disabled={sendJGKToPostAmount < 1 ? true : false}
                          onClick={handleSendJGKToPostAmount}
                        >
                          {isLoading ? (
                            <CircularProgress color="inherit" size="20px" />
                          ) : (
                            'Send'
                          )}
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            )}
            {!localOpsMeta ? (
              <>
                <div
                  className={
                    post?.isPogw
                      ? post?.jgkd.includes(loggedInPlayer.data.player.playerId) ||
                        post?.playerId === loggedInPlayer.data.player.playerId
                        ? 'postBottom'
                        : 'postBottom myDiv'
                      : 'postBottom'
                  }
                >
                  <Like
                    imgRef={imgRef}
                    text="+2 JGK, Yay!"
                    likes={like}
                    likesProfileImgs={post?.likesProfileImgs}
                    isLiked={isLiked}
                    likeHandler={likeHandler}
                    mobileView={mobileView}
                    PF={PF}
                    title={isLiked ? 'You liked this' : ''}
                    width={width}
                    textOffset={post?.isPogw ? -13 : -20}
                  />
                </div>
                <div style={{ margin: '6px 0' }}>
                  <ReactionBar
                    post={post}
                    currentPlayer={currentPlayer.data.player}
                    onReact={handleReact}
                  />
                </div>
              </>
            ) : null}

            {dialogIsSupported && (
              <div className="sharePostModal" title="Share Post">
                <div className="shareCountDiv">
                  <div className="sendOutlinedIcon">
                    <SendOutlinedIcon
                      onClick={() => {
                        setModal(true);
                      }}
                    />
                  </div>
                  <span className="postRePostCounter">
                    {share > 0 ? share : null}
                  </span>
                  <span
                    className={
                      !mobileView ? 'postLikeCounter' : 'postLikeCounterMobile'
                    }
                  >
                    {width > 280 &&
                      (share === 1
                        ? ' share'
                        : share > 1
                        ? ' shares '
                        : 'be 1st to share ')}
                  </span>
                </div>

                <Modal openModal={modal}>
                  <div
                    className={
                      darkTheme
                        ? 'modalContent darkTheme blackBg'
                        : 'modalContent'
                    }
                  >
                    <div className="modalHeaders">
                      {!isRepost && (
                        <div className="shareDiv">
                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check
                                  ref={checkbox}
                                  type={type}
                                  id={`${player._id}`}
                                  // label={` Share`}
                                  onClick={(e) => {
                                    handleIsShareClicked();
                                  }}
                                />
                              </div>
                            ))}
                          </Form>
                          <h2 className="modalHeader">Share</h2>
                        </div>
                      )}

                      {!isShare &&
                        loggedInPlayer.data.player.playerId !==
                          post?.playerId && (
                          <div className="repostDiv">
                            <Form>
                              {['checkbox'].map((type) => (
                                <div key={`default-${type}`} className="mb-3">
                                  <Form.Check
                                    ref={checkbox}
                                    type={type}
                                    id={`${player._id}`}
                                    // label={` Share`}
                                    onClick={(e) => handleIsRepostClicked()}
                                  />
                                </div>
                              ))}
                            </Form>
                            <h2 className="modalHeader">Repost</h2>
                          </div>
                        )}
                    </div>
                    {!isRepost && (
                      <>
                        <div>To: </div>
                        <div
                          className={
                            darkTheme
                              ? 'postRequestPlayersSearchResults darkTheme blackBg'
                              : 'postRequestPlayersSearchResults'
                          }
                        >
                          {
                            <MyFriendsToSharePost
                              searchedPlayers={myFriends}
                              myFriendsToSharePost={myFriendsToSharePost}
                              SetMyFriendsToSharePost={SetMyFriendsToSharePost}
                            />
                          }
                        </div>
                      </>
                    )}

                    <div className="postShareCloseSend topright">
                      <button
                        className="sharePostSubmitButton"
                        onClick={() => {
                          setModal(false);
                        }}
                      >
                        x
                      </button>
                    </div>

                    <div className="postShareCloseSend">
                      <button
                        className={
                          (myFriendsToSharePost &&
                            myFriendsToSharePost.length > 0) ||
                          isRepost
                            ? 'sharePostSubmitButton'
                            : 'sharePostSubmitButtonDisabled'
                        }
                        onClick={isShare ? handleSharePost : handleRepost}
                        disabled={
                          (myFriendsToSharePost &&
                            myFriendsToSharePost.length > 0) ||
                          isRepost
                            ? false
                            : true
                        }
                      >
                        {loading ? (
                          <CircularProgress color="inherit" size="20px" />
                        ) : isShare ? (
                          'Send'
                        ) : (
                          'Go'
                        )}
                      </button>
                    </div>
                  </div>
                </Modal>
              </div>
            )}
            <div
              className={
                post?.isPogw
                  ? post?.jgkd.includes(loggedInPlayer.data.player.playerId) ||
                    post?.playerId === loggedInPlayer.data.player.playerId
                    ? 'commentBottom'
                    : 'commentBottom myDiv'
                  : 'commentBottom'
              }
            >
              <div className="comments_wrap">
                <CreateComment
                  postId={post?._id}
                  setComments={setComments}
                  setCommentCount={setCommentCount}
                  parent="Post"
                  socket2={socket2}
                />
                {commentTypingHint && (
                  <div
                    style={{
                      fontSize: 12,
                      color: '#6c63ff',
                      margin: '4px 2px 6px',
                      fontWeight: 600,
                    }}
                  >
                    {commentTypingHint}
                  </div>
                )}

                <span className="postCommentText">
                  {sortedComments
                    .slice(0, commentCountRef.current)
                    .map((comment) => (
                      <Comment
                        comment={comment}
                        key={comment._id}
                        postId={post?._id}
                        imgRef={imgRef}
                      />
                    ))}
                  {commentCountRef.current <
                    (comments ? comments?.length : 0) && (
                    <div
                      className={`${
                        !mobileView ? 'viewComments' : 'viewCommentsMobile'
                      } ${darkTheme ? 'app dark-theme' : ''}`}
                      onClick={() => showMore()}
                    >
                      View {comments?.length - commentCountRef.current} more{' '}
                      {comments?.length - commentCountRef.current === 1
                        ? 'comment'
                        : 'comments'}
                    </div>
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </Tooltip>
    </>
  );
}






